import React from 'react';
import moment from 'moment';
import { getDollarFormat, getNumberFormat } from 'utils/helpers';
import NoDataMsg from 'library/noData';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip } from "recharts";

let row = (item, index) => (
    <div className="row m-0 border_bottom_grey mb-2 pb-2  result-list" key={index}>
        <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 m-0  center_xs">
            <h4 className="mb-0 capitalize purpleText">{item.budtender}</h4>
            <label className="font-italic">ID: {item.employeeId}</label>
            <h5 className='purpleText'>Timesheet:<br /> {item.totalhours} hrs.  {item.totalminutes} mins</h5>
            <h5 >Average Transaction Speed Per Order:<br /> {item.avgtransactiontime} mins</h5>
            <h5>Number of Orders Per Hour: <br />
                {(item.numberOfOrders > 0 && item.totalhours + item.totalminutes > 0)
                    ? ((item.totalhours + item.totalminutes / 60) / item.numberOfOrders).toFixed(2)
                    : "0"}
            </h5>
        </div>
        <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12 m-0 p-0 text-center">
            <div className="row m-0">
                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <div className='row' >
                        {/* ORDERS */}
                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3 m-0 p0">
                            {/* <div className="table_icon"><NavigationCheck/></div> */}
                            <label># of Orders Completed</label>
                            <h5 className="m-0 green-text md-font">{item.numberOfOrders}</h5>
                        </div>
                        {/* AVERAGE PER ORDER */}
                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3 m-0 p-0">
                            {/* <div className="table_icon"><ActionTrendingUp/></div> */}
                            <label>Avg. per Order</label>
                            <h3 className="m-0 green-text md-font">{getDollarFormat(item.salesOfAverageByOrder)}</h3>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3 m-0 p-0">
                            {/* <div className="table_icon"><EditorAttachMoney/></div> */}
                            <label>Discounts</label>
                            <h3 className="m-0 green-text md-font">{getDollarFormat(item.totalDiscounts)}</h3>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3 m-0 p-0">
                            {/* <div className="table_icon"><EditorAttachMoney/></div> */}
                            <label>Tips Recieved</label>
                            <h3 className="m-0 green-text md-font">{getDollarFormat(item.totalTips)}</h3>
                        </div>
                    </div>

                </div>
                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <div className='row'  >
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 m-0 p-0">
                            {/* <div className="table_icon"><EditorAttachMoney/></div> */}
                            <label>Cannabis Gross Sales</label>
                            <h3 className="m-0 green-text md-font">{getDollarFormat(item.cannabisGrosssales)}</h3>
                            <p className="m-0">{item.cannabispercentage.toFixed(2)}%</p>
                        </div>

                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 m-0 p-0">
                            {/* <div className="table_icon"><EditorAttachMoney/></div> */}
                            <label>Non-Cannabis Gross Sales</label>
                            <h3 className="m-0 green-text md-font">{getDollarFormat(item.noncannabisGrosssales)}</h3>
                            <p className="m-0">{item.noncannabispercentage.toFixed(2)}%</p>
                        </div>
                        {/* GROSS SALES */}
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 m-0 p-0">
                            {/* <div className="table_icon"><EditorAttachMoney/></div> */}
                            <label>Gross Sales</label>
                            <h3 className="m-0 green-text md-font">{getDollarFormat(item.totalGrosssales)}</h3>
                        </div>
                    </div>

                </div>
            </div>
            <br />

            <div className="row m-0">
                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <div className='row' >
                        {/* DEBIT CARD */}
                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3 m-0 p0">
                            {/* <div className="table_icon"><ActionCreditCard/></div> */}
                            <label>Debit Card</label>
                            <h3 className="m-0 green-text md-font">{getDollarFormat(item.debitTotal)}</h3>
                            {/*<h4 className="grey-text"><i>Total:</i> {item.numberOfDebits}</h4>*/}
                        </div>
                        {/* CREDIT CARD */}
                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3 m-0 p0">
                            {/* <div className="table_icon"><ActionCreditCard/></div> */}
                            <label>Debit Card</label>
                            <h3 className="m-0 green-text md-font">{getDollarFormat(item.creditsTotal)}</h3>
                            {/*<h4 className="grey-text"><i>Total:</i> {item.numberOfDebits}</h4>*/}
                        </div>
                        {/* CASH */}
                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3 m-0 p0">
                            {/* <div className="table_icon"><EditorAttachMoney/></div> */}
                            <label>Cash</label>
                            <h3 className="m-0 green-text md-font">{getDollarFormat(item.cashTotal)}</h3>
                            {/*<h4 className="grey-text"><i>Total:</i> {item.numberOfCashes}</h4>*/}
                        </div>
                        {/* STORE CREDIT */}
                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3 m-0 p0">
                            {/* <div className="table_icon"><ActionStore/></div> */}
                            <label>Store Credit</label>
                            <h3 className="m-0 green-text md-font">{getDollarFormat(item.storeCreditTotal)}</h3>
                            {/*<h4 className="grey-text"><i>Total:</i> {item.numberOfStoreCredits}</h4>*/}
                        </div>
                    </div>

                </div>
                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <div className='row' >
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 m-0 p-0">
                            {/* <div className="table_icon"><EditorAttachMoney/></div> */}
                            <label>Cannabis Quantity</label>
                            <h3 className="m-0 green-text md-font">{getNumberFormat(item.cannabisQuantity)}</h3>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 m-0 p-0">
                            {/* <div className="table_icon"><EditorAttachMoney/></div> */}
                            <label>Non-Cannabis Quantity</label>
                            <h3 className="m-0 green-text md-font">{getNumberFormat(item.noncannabisQuantity)}</h3>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </div>)

const Body = ({ budtenderAvgSales, budtenderAvgSalesFiltered, endDate, beginDate, dataForPlotting, customTooltip }) => (
    <div>
        {
            budtenderAvgSales.results && budtenderAvgSales.results.length <= 0 ?
                //If there's NO DATA to display
                <NoDataMsg />
                :
                budtenderAvgSales.results && budtenderAvgSales.results.length > 0 &&
                //If there's DATA
                <div>
                    <div className="row m-0">
                        <div className="text-center list_header">
                            {beginDate ?
                                <p><i>From</i> <b>{moment(beginDate).format('MMMM Do, YYYY')}</b> <i> to </i>
                                    {endDate ? <b>{moment(endDate).format('MMMM Do, YYYY')}</b> : moment().format('MMMM Do, YYYY')}</p>
                                : moment().format('MMMM D, YYYY')}
                        </div>
                    </div>

                    <div className="row m-0">
                        <h3 className="text-center">Employee Sales Performance</h3>
                        <ResponsiveContainer width={"100%"} height={50 * dataForPlotting(budtenderAvgSales).length} debounce={50}>
                            <BarChart
                                data={dataForPlotting(budtenderAvgSales)}
                                layout="vertical"
                                margin={{ left: 50, right: 150 }}
                            >
                                <XAxis type="number" tick={{ fontSize: 10 }} />
                                <YAxis
                                    yAxisId={0}
                                    dataKey="budtender"
                                    type="category"
                                    tick={{ fontSize: 10 }}
                                    interval={0}
                                />
                                <YAxis
                                    orientation="right"
                                    type="category"
                                    tickFormatter={value => value.toLocaleString()}
                                    mirror
                                    tick={{
                                        transform: `translate(150, 0)`,
                                        fontSize: 10
                                    }}
                                />
                                <Bar dataKey={"grossSalesPercentage"} minPointSize={2} barSize={25} fill={'#7a60e5'} />
                                <Tooltip content={customTooltip} cursor={{ fill: "#D4D1FF20" }} />
                            </BarChart>
                        </ResponsiveContainer>
                        <br />
                    </div>
                    <br />
                    <div className="row m-0">
                        <div className="col-lg-12 title_summary">
                            <h3 className="m-0">Detailed Summary</h3>
                        </div>
                        <div className="col-lg-3 col-md-3 text-center">
                            <p><i>Note: "Debit Card", "Credit Card", "Cash" and "Store Credits" includes tax</i></p>
                        </div>
                    </div>

                    <div className="mt-2 pl-2 pr-2">
                        {
                            budtenderAvgSales.selectedEmployeeId != 0 ?
                                budtenderAvgSalesFiltered.length == 0 ? <NoDataMsg /> :
                                    budtenderAvgSalesFiltered.map((item, index) => {
                                        return (
                                            row(item, index)
                                        )
                                    })
                                :
                                budtenderAvgSales.results.map((item, index) => {
                                    return (
                                        row(item, index)
                                    );
                                })
                        }
                    </div>
                </div>
        }
    </div>
);

export default Body;